


























































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { FormState } from '@/components/prine/enums/FormState';
import DetailedConfirmModal from '@/components/prine/DetailedConfirmModal.vue';

import type { User } from '@/models/user';
import PrineButton from '@/components/prine/PrineButton.vue';
import type { XProcess } from '@/models/xprocess';
import { xProcessWebservice } from '@/webservices/xprocess';
import type { CompanySetting } from '@/models/companySetting';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'StoreUpdateXProcess',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },

    methods: { hasPermission },
    components: {
        DetailedConfirmModal,
        PrineButton,
    },
})
export default class StoreUpdateXProcess extends Vue {
    public FormState = FormState;

    // Data
    protected disabled: boolean = false;
    protected errorMsg: string = '';
    protected isConfirmModalActive: boolean = false;
    protected state: FormState = FormState.New;

    protected xprocess: XProcess = {} as XProcess;

    protected loading = {
        data: false,
        color: '#fdc05d',
        size: '40px',
    };

    protected affectedData: Map<string, number> = new Map();

    @Getter('account/userInfo') private userInfo: User;

    @Getter('account/companySetting') private companySetting: CompanySetting;
    @Getter('utils/currentLocale') private currentLocale: string;

    // Mounted is called initially
    private mounted() {
        if (this.$route.query.hasOwnProperty('phaseId')) {
            this.load(this.$route.query.phaseId.toString());
            this.state = FormState.Update;
        }
    }

    private load(processId: string) {
        const self = this;
        this.loading.data = true;
        xProcessWebservice.getById(processId).then((response) => {
            this.xprocess = response.data;
            this.loading.data = false;

            this.affectedData.set(this.$tc('keywords.lesson', 2).toString(), this.xprocess.x_lessons_count);
            this.affectedData.set(this.$tc('keywords.worksheets', 2).toString(), this.xprocess.x_worksheets_count);
            // this.affectedData.set(this.$tc('keywords.project', 2).toString(), this.xprocess.projects_count);
        });
    }

    private save() {
        this.disabled = true;
        const self = this;
        if (!this.validate()) {
            this.disabled = false;
            return 0;
        }

        if (this.state === FormState.New) {
            xProcessWebservice
                .store(this.xprocess)
                .then((response) => {
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: this.$t('toastMessages.store.generic', {
                            x:
                                this.currentLocale === 'en'
                                    ? this.companySetting.x_en_process_title
                                    : this.companySetting.x_de_process_title,
                        }).toString(),
                        type: 'is-success',
                    });
                    this.$emit('syncKnowledge');
                    this.$router.push({ path: '/knowledge/combined' });
                })
                .catch((error) => {
                    this.disabled = false;
                    console.log(error);
                });
        } else if (this.state === FormState.Update) {
            xProcessWebservice
                .update(this.xprocess)
                .then((response) => {
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: this.$t('toastMessages.update.generic', {
                            x:
                                this.currentLocale === 'en'
                                    ? this.companySetting.x_en_process_title
                                    : this.companySetting.x_de_process_title,
                        }).toString(),
                        type: 'is-success',
                    });
                    this.$emit('syncKnowledge');
                    this.$router.push({ path: '/knowledge/combined' });
                    this.disabled = false;
                })
                .catch((error) => {
                    this.disabled = false;
                    console.log(error);
                });
        }
    }

    private toggleConfirmModal(answer) {
        this.isConfirmModalActive = !this.isConfirmModalActive;
        if (answer === true) {
            this.remove();
        }
    }

    private remove() {
        const self = this;
        xProcessWebservice
            .remove(this.xprocess)
            .then((response) => {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: this.$t('toastMessages.delete.generic', {
                        x:
                            this.currentLocale === 'en'
                                ? this.companySetting.x_en_process_title
                                : this.companySetting.x_de_process_title,
                    }).toString(),
                    type: 'is-success',
                });
                this.$router.push({ path: '/knowledge/combined' });
                this.$emit('syncKnowledge');
            })
            .catch((error) => {
                console.log(error);
            });
    }

    private validate() {
        if (!this.xprocess.title || this.xprocess.title === '') {
            this.errorMsg = 'title';
            return 0;
        } else if (isNaN(Number(this.xprocess.order))) {
            this.errorMsg = 'orderNotNumber';
            return 0;
        } else {
            return true;
        }
    }
}
